import { useEffect, useState } from 'react'
import AdBlockPopup from './AdBlockPopup'
import { useUser } from '../UserContext'

const AdBlockDetector = () => {
  const [detected, setDetected] = useState(false)
  const user = useUser()

  useEffect(() => {
    // Flag to indicate if ad blocker is detected
    let blocked = false

    // List of common ad-related class names used as bait
    const baitClasses = [
      'adsbox',
      'ad-banner',
      'ad-container',
      'ad',
      'ads',
      'ad-placement',
      'adunit',
      'adblock',
      'doubleclick',
      'ad_area',
      'adzone',
    ]

    // Create bait divs and append to DOM
    const baits = baitClasses.map((cls) => {
      const bait = document.createElement('div')
      bait.className = cls
      bait.style.height = '1px'
      bait.style.width = '1px'
      bait.style.position = 'absolute'
      bait.style.left = '-9999px'
      document.body.appendChild(bait)
      return bait
    })

    // Create a bait iframe and append to DOM
    const iframe = document.createElement('iframe')
    iframe.src = 'https://ads.example.com/ad_iframe.html'
    iframe.style.width = '1px'
    iframe.style.height = '1px'
    iframe.style.position = 'absolute'
    iframe.style.left = '-9999px'
    document.body.appendChild(iframe)

    // Wait 500ms, then check if bait elements were blocked/hidden
    setTimeout(() => {
      // Check each bait div for signs of being blocked
      baits.forEach((bait) => {
        if (
          !bait ||
          bait.offsetHeight === 0 ||
          bait.offsetParent === null ||
          window.getComputedStyle(bait).display === 'none'
        )
          blocked = true
        if (bait.parentNode) bait.parentNode.removeChild(bait)
      })
      // Check iframe for signs of being blocked
      if (
        !iframe ||
        iframe.offsetHeight === 0 ||
        iframe.offsetParent === null ||
        window.getComputedStyle(iframe).display === 'none'
      )
        blocked = true
      if (iframe.parentNode) iframe.parentNode.removeChild(iframe)
      // Set detection state
      setDetected(blocked)
    }, 500)

    // Cleanup on unmount: remove all bait elements
    return () => {
      baits.forEach((bait) => {
        if (bait.parentNode) bait.parentNode.removeChild(bait)
      })
      if (iframe.parentNode) iframe.parentNode.removeChild(iframe)
    }
  }, [user])

  return detected ? <AdBlockPopup /> : null
}

export default AdBlockDetector
